import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminRoutes from './admin'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: function () { return import('../views/ForgotPassword.vue')}
  },
  {
    path: '/register',
    name: 'SignUp',
    component: function () { return import('../views/SignUp/Signup.vue')}
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: function () { return import('../views/SignUp/Quiz.vue')}
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: function () { return import('../views/Dashboard.vue')}
  },
  {
    path: '/logout',
    name: 'Logout',
    component: function () { return import('../views/Logout.vue')}
  },
  {
    path: '/data',
    name: 'Admin',
    component: function () { return import('../views/admin/Admin.vue')},
    children: AdminRoutes
    //AdminRoutes
  },
  {
    path: '/vedomost',
    name: 'AdminVedomost',
    component:  function () { return import('../views/admin/AdminVedomost.vue')}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
